import Barba from 'barba.js';
import $ from 'jquery';
import slider from '../../modules/slider.js';
import projecthover from '../../modules/project-hover.js';
import error from '../../modules/error.js';
import {startScroll, stopScroll} from '../../modules/scroll-ease';
import MagnificPopup from 'magnific-popup';


var defaultView = function() {

  var Default = Barba.BaseView.extend({
    namespace: 'default',
    onEnter: function() {
      slider();
      projecthover();

        $('.lb-trigger').magnificPopup({
          type: 'image',
          disableOn: 700,
          preloader: false,
          overflowY: 'hidden',
          closeOnContentClick: true,
          fixedContentPos: true,
          fixedBgPos: true,
          showCloseBtn: false,

          callbacks: {
            open: function() {
              stopScroll();
            },
            close: function() {
              startScroll();
            }
          }
        });


      if($('body.error404').length) {
        error();
      }

    },
    onEnterCompleted: function() {
      $(window).scroll();
    },
    onLeave: function() {
    },
    onLeaveCompleted: function() {
    }
  });

  Default.init();
}

module.exports = defaultView;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/default-view.js